import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/storage';
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {

  apiKey: "AIzaSyCavv3zaKJE7onxNwpkNJKSJAo9kJ-wWlQ",

  authDomain: "ayla-4f177.firebaseapp.com",

  projectId: "ayla-4f177",

  storageBucket: "ayla-4f177.firebasestorage.app",

  messagingSenderId: "840734610652",

  appId: "1:840734610652:web:8909885bc606f4fe611019",

  measurementId: "G-Y7DTL0WDS0"

};


const app = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const storage = getStorage(app);
const firestore = getFirestore(app);
const analytics = getAnalytics(app);

export { auth, storage, firestore, analytics };
